import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { StatisticOperationDetails } from 'src/features/statistics/types';
import type { ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/statistics/validation/details/';

interface DTO {
    parkingId: string;
    from_date?: string;
    to_date?: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<StatisticOperationDetails>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_VALIDATION_DETAILS_STATISTICS_RESOURCE,
    queryFn as listValidationDetailsStatistics,
    useQueryHook as useListValidationDetailsStatistics,
};
